export default "https://assets.pclncdn.com/web/next-landing/d6942e80/_next/static/images/cobrand-topcashback-promo-7ef7dabf7363f6db117e2c0021a467d6.jpg";